import React from 'react';
import LeftSideBar from './sidebar/LeftSideBar';
import RightContent from './content/rightContent';


const sidingHome = () => {
  return (
    <div className="h-full flex flex-col lg:flex-row">
      <LeftSideBar/>
      <RightContent />
    </div>
  );
}

export default sidingHome;
